import axios from "axios";
import {Api_url} from "./NETWORKCONSTS";

export function ws_getMessages(userId, appName = "WEBAPP") {
    return axios.get(Api_url.ws.messages, {params: {UserId: userId, AppName: appName}});
}

export function ws_markRead(userId, appName = "WEBAPP") {
    return axios.post(Api_url.ws.markRead, {UserId: userId, AppName: appName});
}
